import { Converter } from '@lumapps/wrex-core/serialization/dita/toDITA/types';

import { AttachmentElement } from '../../types';
import { createAttachmentsTopic } from './createAttachmentsTopic';

/** Convert slate attachments to DITA attachments topic. */
export const ATTACHMENTS_CONVERT: Converter<AttachmentElement> = (node, children = []) => {
    return createAttachmentsTopic(children);
};
